import { Stack, Typography, styled, type CSSObject } from '@mui/material';
import { Button } from '@rumblefish/ui/src/components/Rumblefish23Theme';

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  marginTop: theme.spacing(6),

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 9, 0),
    gap: theme.spacing(4),
  },
}));

export const StyledContentStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(10),

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
}));

export const StyledTextStack = styled(Stack)(({ theme }) => ({
  flex: 0.85,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.down('xl')]: {
    flex: 0.95,
  },
  [theme.breakpoints.down('lg')]: {
    flex: 1,
  },
}));

export const StyledAccordionStack = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: '850px',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    minHeight: 'auto',
    marginBottom: theme.spacing(0),
  },
}));

export const StyledLinkWrapper = styled(Stack)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: theme.spacing(2, 0, 1, 1),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.orangeColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.orangeColors?.PLUS_2} inset !important`,
  },
}));

export const MainText = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));
